// template types
export const ONE_TO_ONE_TEMPLATE_TYPE = 'single_account';
export const MULTI_EVENT_TEMPLATE_TYPE = 'one_slot_multiple_event';
export const ALL_ROUND_ROBIN_TEMPLATE_TYPES = [
  'round_robin_availability',
  'round_robin_fairness',
] as const;
export const PANEL_TEMPLATE_TYPE = 'panel_interview';
export const SEQUENTIAL_INTERVIEW_TEMPLATE_TYPE = 'sequential_interview';

export const TIMEZONE_WARNING_THRESHOLD = 180;

// booking types
export const CALENDAR_AVAILABILITY = 'calendar_availability';
export const WORKING_HOURS = 'working_hours';

// event notification types
export const REMINDERS = 'reminders';
export const CANCEL_EVENT = 'cancelEvent';
export const SCHEDULE_EVENT = 'scheduleEvent';
export const RESCHEDULE_EVENT = 'rescheduleEvent';
export const REQUEST_RESCHEDULE_EVENT = 'requestRescheduleEvent';
export const POST_EVENT_NOTIFICATION = 'postEventNotification';

// recipient types
export const HOST = 'HOST';
export const CANDIDATE = 'CANDIDATE';
export const HOST__CANDIDATE = 'HOST__CANDIDATE';
export const ALL_INTERVIEWERS = 'ALL_INTERVIEWERS';
export const HOST__REQUIRED_INTERVIEWERS = 'HOST__REQUIRED_INTERVIEWERS';

// delivery channel type
export const EMAIL = 'email';
export const SMS = 'sms';
export const WHATSAPP = 'whatsapp';

// booking slot types
export const WEEK_BASED_SLOT = 'week_based_slot';
export const DATE_BASED_SLOT = 'date_based_slot';
export const TIME_BLOCK_BASED_SLOT = 'timeblock_based_slot';

// conflict prevention rule types
export const CONFLICT_PREVENTION_DATE_BASED = 'conflict_prevention_date_based';
export const CONFLICT_PREVENTION_EVENT_BASED =
  'conflict_prevention_event_based';
export const CONFLICT_PREVENTION_EVENT_OUTSIDE_SENSE =
  'conflict_prevention_event_outside_sense';

// no availability rule types
export const NO_AVAILABILITY_RULE = 'no_availability_rule';

// max interviewers count for warning
export const MAX_INTERVIEWERS_COUNT = 10;
